import axios from "axios";
import { API_BASE_URL } from "./constants/api.constants";

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
});


/* ================= REQUEST INTERCEPTOR ================= */

axiosInstance.interceptors.request.use(
  (config) => {

    const token =
      sessionStorage.getItem("accessToken") ||
      localStorage.getItem("accessToken");

    if (token) {
      config.headers = config.headers || {};

      config.headers["x-access-token"] = token;
    }

    return config;

  },
  (error) => Promise.reject(error)
);


/* ================= RESPONSE INTERCEPTOR ================= */

axiosInstance.interceptors.response.use(
  (response) => response,

  (error) => {

    // Optional debugging
    console.error(
      "API ERROR:",
      error.response?.status,
      error.response?.data
    );

    return Promise.reject(error);

  }
);


export default axiosInstance;